<template>
	<div class="operate-Ad-list">
		<template v-for="(item, index) in AdList" :key="index">
			<NuxtLink
				v-if="item.fixedStyle === 1"
				:to="{ path: '/operationalAdvertise', query: { itemId: item.itemId, title: item.title } }"
				:class="['operate-Ad-item', `item_${index}`]"
				@click="onAdClick"
				rel="nofllow"
			>
				<text class="ad-title">{{ item.title }}</text>
				<div class="ad-img-wrap">
					<img :src="item.imgUrl" class="ad-img" :alt="item.title || '运营广告'" />
				</div>
			</NuxtLink>
			<a
				v-else-if="item.linkUrl"
				:href="mateUrl(item.linkUrl) || item.linkUrl"
				rel="nofollow"
				:class="['operate-Ad-item', `item_${index}`]"
				@click.prevent="gotoPage(item)"
			>
				<text class="ad-title">{{ item.title }}</text>
				<div class="ad-img-wrap">
					<img :src="item.imgUrl" class="ad-img" :alt="item.title || '运营广告'" />
				</div>
			</a>
			<div v-else :class="['operate-Ad-item', `item_${index}`]">
				<text class="ad-title">{{ item.title }}</text>
				<div class="ad-img-wrap">
					<img :src="item.imgUrl" class="ad-img" :alt="item.title || '运营广告'" />
				</div>
			</div>
		</template>
	</div>
</template>

<script setup>
import { jumpTo, mateUrl } from '@/utils/mateUrl.js';

defineProps({
	AdList: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(['click']);

function onAdClick() {
	emit('click');
}

function gotoPage(item) {
	onAdClick();
	if (item.linkUrl) {
		jumpTo(item.linkUrl);
	}
}
</script>

<style lang="scss" scoped>
.operate-Ad-list {
	box-sizing: border-box;
	margin: 0 8px;
	display: grid;
	grid-template-columns: repeat(2, 1fr); /* 创建3列等宽 */
	gap: 0 8px; /* 列之间的间距 */
	border-radius: 5px;
	margin-bottom: 6px;

	.operate-Ad-item {
		height: 115px;
		border-radius: 5px;
		padding: 0px 8px 8px;
		background: linear-gradient(180deg, #ccdfff -8%, #ffffff 36%);
		display: flex;
		flex-direction: column;
		overflow: hidden;
		text-decoration: none;
		color: inherit;

		&.item_1 {
			background: linear-gradient(180deg, #c0eaee -6%, #ffffff 35%);
			.ad-title {
				background: linear-gradient(270deg, #4bdb86 64%, #2c80d9 83%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				background-clip: text;
				// text-fill-color: transparent;
			}
		}
	}

	.ad-img-wrap {
		flex: 1;
		min-height: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 3px;
		overflow: hidden;
	}

	.ad-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 3px;
	}

	.ad-title {
		font-size: 16px;
		font-weight: bold;
		line-height: 32px;
		display: flex;
		align-items: center;
		letter-spacing: 0px;

		background: linear-gradient(270deg, #f07cb4 64%, #5266d8 83%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		// text-fill-color: transparent;
		// text-shadow: 0px 0px 15px rgba(255, 255, 255, 0.5);
		// text-fill-color: transparent;
		// text-shadow: 0px 0px 15px rgba(255, 255, 255, 0.5);
	}
}
</style>
